import notify from "devextreme/ui/notify";

const DISPLAY_TIME = {
    // in milliseconds
    info: 5000,
    warning: 8000,
    error: 10000,
    success: 3000,
};

export function PscsNotify(messageOrObject, type = 'info') {
    let message, notifType, displayTime;
    if (typeof messageOrObject === 'object' && messageOrObject !== null) {
        message = messageOrObject.message;
        notifType = messageOrObject.type || 'info';
        displayTime = messageOrObject.duration ?? DISPLAY_TIME[notifType];
    } else {
        message = messageOrObject;
        notifType = type;
        displayTime = DISPLAY_TIME[notifType];
    }

    notify({
        message,
        type: notifType,
        displayTime,
        closeOnClick: true, // allows user to close the notification banner by clicking on it
    });
}